import { Injectable, EventEmitter } from "@angular/core"
import { environment } from "../../../../environments/environment"
export let isDebugMode = environment.isDebugMode

@Injectable()
export class InputSearchService {

    eventSelect = new EventEmitter<any>()
    constructor() {
        isDebugMode ? console.log(`constructor()`) : undefined
    }

}
